import { MoveEmployeeParams } from 'types/services';
import { getEmployees } from './getEmployees';

export const moveEmployee = async (params: MoveEmployeeParams) => {
  return getEmployees();
};
